import moment from "moment";
import React, { memo } from "react";
import TimeAgo from "react-timeago";

const timezoneRegex = /[+-].{2}:00$/;

const TIME_FORMAT = {
  UTC: "YYYY-MM-DD HH:mm UTC",
  ISO_18061_WITH_SECONDS: "YYYY-MM-DD HH:mm:ss",
  TIME_AGO: "YYYY-MM-DD HH:mm:ss.SSSSZ",
  SHORT_ISO_18061: "YYYY-MM-DD"
};

interface TimeProps {
  time?: string | Date | null;
  isRelative?: boolean;
  format?: keyof typeof TIME_FORMAT;
  className?: string;
  withTitle?: boolean;
  naiveIsUTC?: boolean;
}

const hasTimezoneInfo = (time: string) =>
  time.endsWith("Z") || timezoneRegex.test(time);

const Time: React.FC<TimeProps> = ({
  time,
  isRelative,
  format = "UTC",
  className = "",
  withTitle = false,
  naiveIsUTC = true
}) => {
  if (!time) {
    return <span className={className}>--</span>;
  }
  const shouldAddTimezoneInfo =
    naiveIsUTC && typeof time === "string" && !hasTimezoneInfo(time);

  const adjustedTime = moment.utc(shouldAddTimezoneInfo ? `${time}Z` : time);

  const formattedTime = adjustedTime.format(TIME_FORMAT[format]);

  return isRelative ? (
    <TimeAgo
      date={adjustedTime.format(TIME_FORMAT.TIME_AGO)}
      title={formattedTime}
    />
  ) : (
    <span title={withTitle ? formattedTime : ""} className={className}>
      {formattedTime}
    </span>
  );
};

export default memo(Time);
